export default "__VITE_ASSET__NOvbMwPR__"